import React, { useState } from "react";
import styles from "./PlanningGifting.module.css";
import Footer from "../../components/Footer";
import { getGiftIdeas } from "./getGiftIdeas";
import Header from "../../components/Header";

const pronouns = ["He/His", "She/Her"];
const ages = ["Under 18", "18 - 25", "26 - 35", "36 - 45", "46 - 60", "60+"];
const interestsList = [
  "cooking", "reading", "travel", "gadgets", "video games", "food", "art & craft", "home decor",
  "gardening", "beer", "dogs", "jewellery", "coffee", "music", "wine", "whiskey", "cats",
  "movies", "sports", "fashion", "fitness", "photography", "tech", "outdoors", "board games", "writing"
];

const recipientOptions = [
  "Select or specify",
  "Friend",
  "Partner/Spouse",
  "Family Member",
  "Team Member",
  "Other"
];

const PlanningGifting = () => {
  const [recipient, setRecipient] = useState("");
  const [customRecipient, setCustomRecipient] = useState("");
  const [pronoun, setPronoun] = useState("");
  const [age, setAge] = useState("");
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [anythingElse, setAnythingElse] = useState("");
  const [aiResults, setAiResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInterestClick = (interest) => {
    setSelectedInterests((prev) =>
      prev.includes(interest)
        ? prev.filter((i) => i !== interest)
        : [...prev, interest]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setAiResults([]);
    try {
      const ideas = await getGiftIdeas({
        recipient,
        customRecipient,
        pronoun,
        age,
        selectedInterests,
        anythingElse,
      });
      setAiResults(ideas);
      setLoading(false);
    } catch (err) {
      setError("Failed to generate ideas. Please try again.");
      setLoading(false);
    }
  };

  const isFormValid =
    recipient &&
    (recipient !== "Other (specify)" || customRecipient.trim() !== "") &&
    pronoun &&
    age &&
    selectedInterests.length > 0;

  return (
    <>
      <div className={styles.pageWrapper}>
        <Header />
        <div className={styles.container}>
          <h2 className={styles.heading}>AI Gift Finder</h2>
          <form onSubmit={handleSubmit}>
            <label className={styles.label}>I need a birthday gift for</label>
            <select
              className={styles.select}
              value={recipient}
              onChange={(e) => setRecipient(e.target.value)}
              required
            >
              {recipientOptions.map((opt) => (
                <option key={opt} value={opt === "Select or add new" ? "" : opt}>
                  {opt}
                </option>
              ))}
            </select>
            {recipient === "Other" && (
              <input
                className={styles.input}
                type="text"
                placeholder="Please specify"
                value={customRecipient}
                onChange={(e) => setCustomRecipient(e.target.value)}
                required
              />
            )}

            <label className={styles.label}>Their pronoun</label>
            <div className={styles.optionsRow}>
              {pronouns.map((p) => (
                <button
                  type="button"
                  key={p}
                  className={`${styles.optionBtn} ${pronoun === p ? styles.selected : ""}`}
                  onClick={() => setPronoun(p)}
                >
                  {p}
                </button>
              ))}
            </div>

            <label className={styles.label}>Their age</label>
            <div className={styles.optionsRow}>
              {ages.map((a) => (
                <button
                  type="button"
                  key={a}
                  className={`${styles.optionBtn} ${age === a ? styles.selected : ""}`}
                  onClick={() => setAge(a)}
                >
                  {a}
                </button>
              ))}
            </div>

            <label className={styles.label}>What are they into?</label>
            <div className={styles.chipGroup}>
              {interestsList.map((interest) => (
                <button
                  type="button"
                  key={interest}
                  className={`${styles.chip} ${selectedInterests.includes(interest) ? styles.selected : ""}`}
                  onClick={() => handleInterestClick(interest)}
                >
                  {interest}
                </button>
              ))}
            </div>

            <label className={styles.label}>Anything else</label>
            <textarea
              className={styles.textarea}
              placeholder="Specify here..."
              value={anythingElse}
              onChange={(e) => setAnythingElse(e.target.value)}
            />

            <div className={styles.buttonRow}>
              <button
                className={styles.button}
                type="submit"
                disabled={loading || !isFormValid}
              >
                {loading ? "Generating..." : "Suggest Gift Ideas"}
              </button>
            </div>
          </form>
          {error && <div style={{ color: "red", marginTop: 16 }}>{error}</div>}
          {aiResults.length > 0 && (
            <div className={styles.resultsSection}>
              <h3 className={styles.resultsHeading}>Here are your picks ✦</h3>
              {aiResults.map((item, idx) => (
                <div key={idx} className={styles.suggestionCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.budgetBadge}>{item.budget}</span>
                    <span className={styles.cardNumber}>{String(idx + 1).padStart(2, "0")}</span>
                  </div>
                  <div className={styles.suggestionTitle}>{item.title}</div>
                  <div className={styles.suggestionDesc}>{item.desc}</div>
                  {item.why && (
                    <div className={styles.whyText}>✦ {item.why}</div>
                  )}
                  {item.tags && item.tags.length > 0 && (
                    <div className={styles.tags}>
                      {item.tags.map((tag) => (
                        <span key={tag} className={styles.tag}>{tag}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PlanningGifting;